import { useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";

const parsePage = (value) => {
    const n = Number.parseInt(value || '1', 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
};

const parsePageSize = (value) => {
    const n = Number.parseInt(value || '10', 10);
    return Number.isFinite(n) && n > 0 ? n : 10;
};

const useListFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const search = searchParams.get('search') || undefined;

    const [total, setTotal] = useState(0);
    const pagination = {
        current: parsePage(searchParams.get('page')),
        pageSize: parsePageSize(searchParams.get('limit')),
        total,
    };

    const [sortParams, setSortParams] = useState({
        sortOrder: undefined,
        sortField: undefined,
    });
    const [loading, setLoading] = useState(true);
    const [selectedRows, setSelectedRows] = useState([]);

    const setSearch = useCallback((value) => {
        setSearchParams(prev => {
            const params = new URLSearchParams(prev);
            if (value) {
                params.set('search', value);
            } else {
                params.delete('search');
            }
            params.set('page', '1');
            return params;
        });
    }, [setSearchParams]);

    const setPagination = useCallback(({ current, pageSize, total } = {}) => {
        if (total !== undefined) setTotal(total);
        if (current !== undefined || pageSize !== undefined) {
            setSearchParams(prev => {
                const params = new URLSearchParams(prev);
                if (current !== undefined) params.set('page', String(current));
                if (pageSize !== undefined) params.set('limit', String(pageSize));
                return params;
            });
        }
    }, [setSearchParams]);

    return {
        search,
        setSearch,
        pagination,
        setPagination,
        sortParams,
        setSortParams,
        loading,
        setLoading,
        selectedRows,
        setSelectedRows,
    }
}

export default useListFilters